import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id, PagedParams, PagedResponse, getQueryKey, invalidateAfterDelete } from '@feature/utils';

import * as api from './CourseApi';
import { Course, CourseRequest } from './CourseTypes';

const courseKey = getQueryKey('course');

export function getCoursePagedOptions(params: PagedParams): UseSuspenseQueryOptions<PagedResponse<Course>> {
  return {
    queryKey: courseKey.paged(params),
    queryFn: () => api.getPaged(params),
  };
}

export function getCourseOptions(courseId: Id): UseSuspenseQueryOptions<Course> {
  return {
    queryKey: courseKey.one(courseId),
    queryFn: () => api.get(courseId),
  };
}

export function useCourseEdit(courseId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: CourseRequest) => api.edit(courseId, request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: courseKey.root(),
      }),
  });
}

export function useCourseCreate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: CourseRequest) => api.create(request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: courseKey.root(),
      }),
  });
}

export function useCourseDelete(courseId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.deleteById(courseId),
    onSuccess: () => invalidateAfterDelete(queryClient, courseKey, courseId),
  });
}
